'use client';

import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { DownOutlined } from '@ant-design/icons';

const ACCORDION_VARIANTS = {
  collapse: { height: 0, opacity: 0, marginTop: 0 },
  expand: {
    height: 'auto',
    opacity: 1,
    marginTop: 16,
    transition: {
      height: { duration: 0.3, ease: 'easeInOut' },
      opacity: { duration: 0.2, delay: 0.05 }
    }
  }
};

export default function SafetyAccordion({ sections = [], title }) {
  const [isOpen, setIsOpen] = useState(true);
  return (
    <section className="w-full max-w-7xl mx-auto p-4 font-sans text-[#2C3E50]">
      <div className="w-full bg-[#F9F6F0] rounded-2xl p-5 md:p-6 border border-gray-100 shadow-sm">
        <button
          aria-label="Dropw"
          type="button"
          onClick={() => setIsOpen(!isOpen)}
          className="w-full flex items-center justify-between text-left group focus:outline-none"
          aria-expanded={isOpen}
        >
          <h3 className="text-lg md:text-xl font-bold tracking-wide text-p-orange group-hover:text-p-orange/70 transition-colors">
            {title}
          </h3>
          <div className="w-8 h-8 md:w-9 md:h-9 bg-p-blue hover:bg-p-blue/70 text-white rounded-full flex items-center justify-center transition-colors shadow-sm">
            <motion.span
              animate={{ rotate: isOpen ? 180 : 0 }}
              transition={{ duration: 0.2, ease: 'easeInOut' }}
              className="text-sm md:text-base font-bold flex items-center justify-center"
            >
              <DownOutlined />
            </motion.span>
          </div>
        </button>
        <AnimatePresence initial={false}>
          {isOpen && (
            <motion.div
              variants={ACCORDION_VARIANTS}
              initial="collapse"
              animate="expand"
              exit="collapse"
              className="overflow-hidden"
            >
              <hr className="border-orange-200/60 mb-5" />
              {!Array.isArray(sections) || sections.length === 0 ? (
                <p className="text-gray-400 italic text-sm pl-1">No data available.</p>
              ) : (
                <ul className="flex flex-col gap-4 pl-1">
                  {sections.map((item, index) => (
                    <SafetyItem
                      key={item.id || index}
                      text={item.coment}
                    />
                  ))}
                </ul>
              )}
            </motion.div>
          )}
        </AnimatePresence>

      </div>
    </section>
  );
}

const SafetyItem = React.memo(({ text }) => {
  return (
    <li className="flex items-start gap-3 text-sm md:text-base text-p-blue font-medium leading-relaxed">
      <span className="flex-shrink-0 w-4 h-4 rounded-full border-2 border-dashed border-p-orange flex items-center justify-center mt-1 relative">
        <span className="w-1.5 h-1.5 bg-p-orange rounded-full" />
      </span>
      <span>{text}</span>
    </li>
  );
});

SafetyItem.displayName = 'SafetyItem';